import {
  cancelAppleAuth,
  cancelGoogleAuth,
  signInWithCustomAuthToken,
} from "@/helpers/flutter/features/auth";
import {
  registerFcmToken,
  setNotificationPermissionStatus,
} from "@/helpers/flutter/features/notifications";
import { flutterToast } from "@/helpers/flutter/features/toast";
import {
  handleShortTransferStart,
  handleShortTransferChunk,
  handleShortTransferComplete,
  handleShortTransferError,
  handleShortCameraDismissed,
} from "@/helpers/flutter/features/shorts-bridge";
import { sendLanguageToFlutter } from "@/helpers/flutter/features/language";

/**
 * Initializes Flutter functions and exposes them to the Flutter side
 */
export function registerFlutterFunctions(): void {
  window.flutterFunctions = {};
  window.flutterFunctions.setToast = flutterToast;
  window.flutterFunctions.cancelAppleAuth = cancelAppleAuth;
  window.flutterFunctions.cancelGoogleAuth = cancelGoogleAuth;
  window.flutterFunctions.setCustomIdToken = signInWithCustomAuthToken;
  window.flutterFunctions.setNotificationPermissionStatus =
    setNotificationPermissionStatus;
  window.flutterFunctions.postFcmToken = registerFcmToken;
  window.flutterFunctions.onShortTransferStart = handleShortTransferStart;
  window.flutterFunctions.onShortTransferChunk = handleShortTransferChunk;
  window.flutterFunctions.onShortTransferComplete = handleShortTransferComplete;
  window.flutterFunctions.onShortTransferError = handleShortTransferError;
  window.flutterFunctions.onShortCameraDismissed = handleShortCameraDismissed;
  window.flutterFunctions.requestLanguage = () => {
    sendLanguageToFlutter();
  };
}
